import { get, post, put, del, postFormData } from './client.js';

export const Auth = {
  login: (email, password) => post('/auth/login', { email, password }),
  me:       () => get('/auth/me'),
  logout:   () => post('/auth/logout', {}),
  changePassword: (current_password, new_password) =>
    post('/auth/change-password', { current_password, new_password }),
};

const crud = (base) => ({
  list:   (q) => get(base, q),
  get:    (id) => get(`${base}/${id}`),
  create: (b)  => post(base, b),
  update: (id, b) => put(`${base}/${id}`, b),
  remove: (id) => del(`${base}/${id}`),
});

export const Categories    = crud('/categories');
export const Subcategories = crud('/subcategories');
export const Locations     = crud('/locations');
export const Clients       = crud('/clients');
export const Responsibles  = crud('/responsibles');
export const Users         = { ...crud('/users'),
  resetPassword: (id, new_password) => post(`/users/${id}/reset-password`, { new_password }),
  roles:         () => get('/users/roles'),
  permissions:   () => get('/users/permissions'),
};

export const Items = {
  ...crud('/items'),
  history:      (id, q) => get(`/items/${id}/history`, q),
  adjustStock:  (id, delta, reason) => post(`/items/${id}/stock-adjust`, { delta, reason }),
  uploadImages: (id, files) => {
    const fd = new FormData();
    for (const f of files) fd.append('images', f);
    return postFormData(`/items/${id}/images`, fd);
  },
  removeImage: (id, imageId) => del(`/items/${id}/images/${imageId}`),
};

export const ItemUnits = {
  ...crud('/item-units'),
  lookup:   (code) => get(`/item-units/lookup/${encodeURIComponent(code)}`),
  setStatus:(id, status, reason) => post(`/item-units/${id}/status`, { status, reason }),
  transfer: (id, current_location_id, reason) => post(`/item-units/${id}/transfer`, { current_location_id, reason }),
  history:  (id, q) => get(`/item-units/${id}/history`, q),
};

export const Loans = {
  list:   (q) => get('/loans', q),
  get:    (id) => get(`/loans/${id}`),
  create: (b) => post('/loans', b),
  update: (id, b) => put(`/loans/${id}`, b),
  fullReturn:    (id, b) => post(`/loans/${id}/return`, b),
  partialReturn: (id, b) => post(`/loans/${id}/partial-return`, b),
  markLost:      (id, lineId, reason) => post(`/loans/${id}/lines/${lineId}/mark-lost`, { reason }),
  sweepOverdue:  () => post('/loans/sweep-overdue', {}),
};

export const Rentals = {
  list:   (q) => get('/rentals', q),
  get:    (id) => get(`/rentals/${id}`),
  create: (b) => post('/rentals', b),
  update: (id, b) => put(`/rentals/${id}`, b),
  activate: (id) => post(`/rentals/${id}/activate`, {}),
  cancel:   (id, reason) => post(`/rentals/${id}/cancel`, { reason }),
  fullReturn:    (id, b) => post(`/rentals/${id}/return`, b),
  partialReturn: (id, b) => post(`/rentals/${id}/partial-return`, b),
  addPayment:    (id, b) => post(`/rentals/${id}/payment`, b),
  addPenalty:    (id, b) => post(`/rentals/${id}/penalty`, b),
  sweepOverdue:  () => post('/rentals/sweep-overdue', {}),
  // Rentas por pasos
  config:      () => get('/rentals/config'),
  apartar:     (id) => post(`/rentals/${id}/apartar`, {}),
  aprobar:     (id) => post(`/rentals/${id}/aprobar`, {}),
  mensaje:     (id, tipo) => post(`/rentals/${id}/mensaje`, { tipo }),
  // Mensajes automáticos y WhatsApp
  mensajesConfig: () => get('/rentals/mensajes/config'),
  conectarWa:  (b) => post('/rentals/whatsapp/conectar', b),
  desconectarWa: () => post('/rentals/whatsapp/desconectar', {}),
  crearPlantillas: () => post('/rentals/whatsapp/plantillas', {}),
  probarMensaje: (b) => post('/rentals/mensajes/probar', b),
  mensajesDe:  (id) => get(`/rentals/${id}/mensajes`),
  enviarCliente: (id) => post(`/rentals/${id}/enviar-cliente`, {}),
  // Google Calendar
  googleEstado: () => get('/rentals/calendario-google'),
  googleConectar: () => post('/rentals/calendario-google/conectar', {}),
  googleCalendarios: () => get('/rentals/calendario-google/calendarios'),
  googleAjustar: (b) => put('/rentals/calendario-google', b),
  googleSincronizar: () => post('/rentals/calendario-google/sincronizar', {}),
  googleDesconectar: (borrar) => post('/rentals/calendario-google/desconectar', { borrar }),
  googleEnlaceNuevo: () => post('/rentals/calendario-google/enlace-nuevo', {}),
  // Fase 8
  extender:    (id, fin) => post(`/rentals/${id}/extender`, { fin }),
  reembolso:   (id, b) => post(`/rentals/${id}/reembolso`, b),
  alquilerEquipo: (itemId) => get(`/rentals/equipo/${itemId}/alquiler`),
  guardarKit:  (itemId, es_kit, componentes) => put(`/rentals/equipo/${itemId}/kit`, { es_kit, componentes }),
  guardarTarifas: (itemId, tarifas) => put(`/rentals/equipo/${itemId}/tarifas`, { tarifas }),
  espera:      () => get('/rentals/espera'),
  atenderEspera: (wid) => post(`/rentals/espera/${wid}/atendida`, {}),
  reporte:     (q) => get('/rentals/reporte', q),
  // Asistentes
  misEntregas: () => get('/rentals/mis-entregas'),
  equipo:      () => get('/rentals/equipo'),
  asignar:     (id, user_id, tarea) => post(`/rentals/${id}/asignar`, { user_id, tarea }),
  quitarAsignacion: (id, aid) => del(`/rentals/${id}/asignar/${aid}`),
  escanear:    (id, codigo) => post(`/rentals/${id}/asistente/escanear`, { codigo }),
  preparado:   (id) => post(`/rentals/${id}/asistente/preparado`, {}),
  asisEntregar: (id, revision) => post(`/rentals/${id}/asistente/entregar`, { revision }),
  asisRecibir:  (id, lineas, fecha) => post(`/rentals/${id}/asistente/recibir`, { lineas, fecha }),
  pagar:       (id, b) => post(`/rentals/${id}/pago`, b),
  credito:     (id) => post(`/rentals/${id}/credito`, {}),
  deposito:    (id, b) => post(`/rentals/${id}/deposito`, b),
  entregar:    (id, revision) => post(`/rentals/${id}/entregar`, { revision }),
  devolver:    (id, lineas, fecha) => post(`/rentals/${id}/devolver`, { lineas, fecha }),
  multa:       (id, b) => post(`/rentals/${id}/multa`, b),
  cerrar:      (id) => post(`/rentals/${id}/cerrar`, {}),
  contratoRequerido: (id, requerido) => post(`/rentals/${id}/contrato-requerido`, { requerido }),
  crearContrato:     (id) => post(`/rentals/${id}/contrato`, {}),
  contratoEnviado:   (id) => post(`/rentals/${id}/contrato/enviado`, {}),
  anularContrato:    (id) => post(`/rentals/${id}/contrato/anular`, {}),
  disponibilidad: (q) => get('/rentals/disponibilidad', q),
  panel:       () => get('/rentals/panel'),
  calendario:  (q) => get('/rentals/calendario', q),
  ocupacion:   (q) => get('/rentals/ocupacion', q),
  creditos:    () => get('/rentals/credito'),
  guardarCredito: (clientId, b) => put(`/rentals/credito/${clientId}`, b),
};

export const Reservations = {
  list:    (q) => get('/reservations', q),
  get:     (id) => get(`/reservations/${id}`),
  create:  (b) => post('/reservations', b),
  update:  (id, b) => put(`/reservations/${id}`, b),
  confirm: (id) => post(`/reservations/${id}/confirm`, {}),
  cancel:  (id) => post(`/reservations/${id}/cancel`, {}),
  convertToLoan:   (id, b) => post(`/reservations/${id}/convert-to-loan`, b),
  convertToRental: (id, b) => post(`/reservations/${id}/convert-to-rental`, b),
  sweepExpired:    () => post('/reservations/sweep-expired', {}),
};

export const Maintenance = {
  list:   (q) => get('/maintenance', q),
  get:    (id) => get(`/maintenance/${id}`),
  create: (b) => post('/maintenance', b),
  update: (id, b) => put(`/maintenance/${id}`, b),
  start:  (id) => post(`/maintenance/${id}/start`, {}),
  complete:(id, b) => post(`/maintenance/${id}/complete`, b),
  cancel: (id, reason) => post(`/maintenance/${id}/cancel`, { reason }),
};

export const Reports = {
  dashboard:   () => get('/reports/dashboard'),
  inventory:   (q) => get('/reports/inventory', q),
  rentals:     (q) => get('/reports/rentals', q),
  loans:       (q) => get('/reports/loans', q),
  maintenance: (q) => get('/reports/maintenance', q),
  financial:   (q) => get('/reports/financial', q),
  topRented:   (limit) => get('/reports/top-rented', { limit }),
};

export const Settings = {
  list:   () => get('/settings'),
  get:    (key) => get(`/settings/${encodeURIComponent(key)}`),
  upsert: (key, value, description) => put(`/settings/${encodeURIComponent(key)}`, { value, description }),
  bulk:   (map) => post('/settings/bulk', map),
};

export const Notifications = {
  list:        (q) => get('/notifications', q),
  unreadCount: () => get('/notifications/unread-count'),
  markRead:    (ids) => post('/notifications/mark-read', { ids }),
  markAllRead: () => post('/notifications/mark-all-read', {}),
  remove:      (id) => del(`/notifications/${id}`),
  generate:    () => post('/notifications/generate', {}),
};

export const Uploads = {
  images: (files) => {
    const fd = new FormData();
    for (const f of files) fd.append('files', f);
    return postFormData('/uploads-api/images', fd);
  },
  documents: (files) => {
    const fd = new FormData();
    for (const f of files) fd.append('files', f);
    return postFormData('/uploads-api/documents', fd);
  },
};

export const Exports = {
  path(kind, params = {}) {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v != null && v !== '') qs.set(k, v);
    }
    const s = qs.toString();
    return `/exports/${kind}${s ? '?' + s : ''}`;
  },
};

export const Documents = {
  rentalContractPath: (id) => `/documents/rentals/${id}/contract`,
  loanReceiptPath:    (id) => `/documents/loans/${id}/receipt`,
};
